export default "__VITE_ASSET__DF0K9GJQ__"